import classNames from "classnames";
import * as React from "react";

interface ISpinnerProps {
    size?: "small" | "default";
    className?: string;
}
const Spinner = ({ size = "default", className }: ISpinnerProps) => {
    const baseClass = "spinner";
    const componentClasses = classNames(baseClass, className, {
        [`${baseClass}--${size}`]: size !== "default"
    });

    return <span className={componentClasses} />;
};

export default Spinner;
